import FetchTextButton, {
  IProps as IFetchTextButtonProps,
} from '../container/FetchTextButton';
import {DEFAULT_MAX_WIDTH} from '../scss/util/variable';

interface IProps extends Omit<IFetchTextButtonProps, 'width'> {
  showGradient?: boolean;
  wrapperClassName?: string;
}

export default function ConfirmButtonV4({
  showGradient = true,
  className,
  textClassName,
  wrapperClassName,
  ...rest
}: IProps) {
  return (
    <div className={cn('flex-center h-50', wrapperClassName)}>
      <FetchTextButton
        className={cn('h-full w-full', className)}
        {...rest}
        style={{maxWidth: `${DEFAULT_MAX_WIDTH}px`}}
        textClassName={textClassName}
        isActiveTextOpacity50
      />
    </div>
  );
}

export const CONFIRM_BTN_SHAPE_CN_V4 =
  'bg-white rounded-25 light:bg-black disabled:!bg-grey-04';
export const CONFIRM_BTN_TEXT_CN_V4 = 's16-bold-black light:text-white';
export const DISABLED_CONFIRM_BTN_TEXT_CN_V4 = 's16-bold-grey02';
